import { find, go, map, range, sel, tap } from 'fxjs/es';
import {
  $addClass,
  $append,
  $closest,
  $data,
  $el,
  $find,
  $findAll,
  $hasClass,
  $position,
  $qs,
  $remove,
  $removeClass,
  $replaceWith,
} from 'fxdom/es';
import {
  ControlSection,
  makePreviewHtml,
  makeSelectedOptionHtml,
  optionsHtml,
} from '../../S/Tmpl/setting.js';
import { NessLabsConstantS } from '../../../S/Constant/module/NessLabsConstantS.js';
import { NessLabsS } from '../../../S/Function/module/NessLabsS.js';
import { MShopUtilF } from '../../../../MShop/Util/F/Function/module/MShopUtilF.js';
import { NessLabsSettingMotionF } from '../../Motion/F/Function/module/NessLabsSettingMotionF.js';
import { NessCustomMakerFrameShareF } from '../../../../NessCustomMaker/Frame/Share/F/Function/module/NessCustomMakerFrameShareF.js';
import { NessLabsSettingConstantS } from '../../S/Constant/module/NessLabsSettingConstantS.js';
import { NessUtilF } from '../../../../Ness/Util/F/Function/module/NessUtilF.js';

export const MotionButtonHandler = {
  chageSelectBox: (ct, { type, value, name, frame_option }) => {
    const control_section = $closest('.motion-controls', ct);
    const motion_section = $find(`.control-section[data-type="${type}"]`, control_section);

    const { id: default_motion_id, frame_no } = go(
      ct,
      $closest('.avatar-setting'),
      $data,
      sel('selected_motions'),
    )[`${type.toLowerCase()}`];

    // 옵션 업데이트
    const select_box = $find(`.motion-select${frame_option ? '.motion-frame-select' : ''}`, motion_section);
    $replaceWith(
      $el(makeSelectedOptionHtml({ value, name, frame_option })),
      $find('.select-selected', select_box),
    );

    // has_value 클래스 토글
    const is_default = value === (frame_option ? frame_no : default_motion_id);
    is_default ? $removeClass('has_value', select_box) : $addClass('has_value', select_box);

    if (!frame_option && type !== NessLabsSettingConstantS.MOTION_TYPES.WEAPON) {
      go(
        motion_section,
        tap((section) => {
          const current_motion = $find('.motion-select .select-selected', section).dataset.value;
          const frame_data = go(
            $find('.motion-select', section),
            $data,
            find(({ motion_id }) => motion_id === current_motion),
            sel('available_frame'),
          );

          const frame_select = $find('.motion-select.motion-frame-select', section);
          $replaceWith($el(ControlSection.makeFrameSelect(frame_data)), frame_select);
        }),
      );
    }
  },

  getActiveMotionsInSelectBox: (container) => {
    const getSelectValue = (selects, is_frame) =>
      go(
        selects,
        Array.from,
        find((el) => (is_frame ? $hasClass('frame_option', el) : !$hasClass('frame_option', el))),
        (el) => el?.dataset?.value,
      );

    return go(
      Object.values(NessLabsSettingConstantS.MOTION_TYPES),
      map((type) => {
        const selects = $findAll(`[data-type="${type}"] .select-selected`, container);
        return {
          id: getSelectValue(selects, false),
          frame_no: getSelectValue(selects, true),
        };
      }),
      (motions) => [...motions, $data(container)],
    );
  },

  updatePreview: async (container, motion_data) => {
    const [emotion, action, weapon, character_data] = motion_data;
    const selected_motions = { emotion, action, weapon };
    const motion_url = NessLabsS.makeCharactersMotionUrl(character_data.maple_image_url, selected_motions);

    PreviewUpdater.change({
      ...character_data,
      maple_image_url: character_data.maple_image_url,
      selected_motions,
    });

    await NessLabsS.initializeCanvases({
      canvas: $find('canvas', container),
      maple_image_url: motion_url,
      size: NessLabsConstantS.CHARACTER_CANVAS_SIZE[NessUtilF.isMobile() ? 'MOBILE' : 'PC'].MAIN,
    });
  },
};

const PreviewUpdater = {
  change: (data) => {
    $replaceWith($el(makePreviewHtml(data)), $qs('.avatar-setting__preview'));
  },
  update: async ({ type, value, name, frame_option }) => {
    const el = $qs(`.control-section[data-type="${type}"]`);
    MotionButtonHandler.chageSelectBox(el, { type, value, name, frame_option });
    const motion_data = MotionButtonHandler.getActiveMotionsInSelectBox($qs('.avatar-setting'));

    MotionButtonHandler.updatePreview($qs('.avatar-setting'), motion_data);
  },
};

export const handleCharacterBySelect = async ({ currentTarget: ct }) => {
  try {
    $.don_loader_start();
    const is_mobile = MShopUtilF.isMobile();
    if (is_mobile) return;

    const { type } = go(ct, $closest('.select-options')).dataset;
    const { value, name, frame_option } = ct.dataset;

    MotionButtonHandler.chageSelectBox(ct, { type, value, name, frame_option });

    const container = $closest('.avatar-setting', ct);
    const motion_data = MotionButtonHandler.getActiveMotionsInSelectBox(container);

    await MotionButtonHandler.updatePreview(container, motion_data);
    closeCurrentOptions();
  } catch (e) {
    console.error(e);
    $.alert(e);
  } finally {
    $.don_loader_end();
  }
};

export const handleCharacterOpenFrame = async ({ currentTarget: ct, is_frame_select }) => {
  try {
    $.don_loader_start();

    if (window.visualViewport) {
      if (window.visualViewport.height !== document.documentElement.clientHeight) {
        // iOS Safari에서 search bar 가 최소화되면서 frame에 빈 공간이 생기는 것을 방지
        // scroll을 최상단으로 이동하는 동작 === search bar 최대화
        window.scrollTo(0, -10);
      }
    }

    const container = go(ct, $closest('.control-section'));
    const type = container.dataset.type;
    const { value, name } = $find('.select-selected', ct).dataset;
    await NessLabsSettingMotionF.openMotionSelector(
      {
        type,
        value,
        name,
        motions: is_frame_select ? getFrameRange(ct) : $data(ct),
        is_frame_select,
      },
      PreviewUpdater.update,
    );
  } catch (e) {
    console.error(e);
  } finally {
    $.don_loader_end();
  }
};
const getFrameRange = (el) => {
  const motion_el = go(
    el,
    $closest('.control-section__selectes'),
    $find('.motion-select:not(.motion-frame-select)'),
  );

  const { value } = $find('.select-selected', motion_el).dataset;

  const { min_frame_no, max_frame_no } = go(
    motion_el,
    $data,
    find(({ motion_id }) => motion_id === value),
    sel('available_frame'),
  );

  min_frame_no === max_frame_no ? $addClass('disabled', el) : $removeClass('disabled', el);

  return range(Number(min_frame_no), Number(max_frame_no) + 1);
};

export const handleMotionSelect = async ({ currentTarget }) => {
  const is_mobile = MShopUtilF.isMobile();
  const is_frame_select = $hasClass('motion-frame-select', currentTarget);

  const motions = is_frame_select ? getFrameRange(currentTarget) : $data(currentTarget);

  if (is_mobile) {
    return await handleCharacterOpenFrame({ currentTarget, is_frame_select });
  }

  const { type } = go(currentTarget, $closest('.control-section')).dataset;
  const selected_value = go(currentTarget, $find(`.select-selected${is_frame_select ? '.frame_option' : ''}`))
    .dataset.value;

  const is_open = currentTarget.classList.contains('open');

  closeCurrentOptions();

  if (!is_open) {
    $addClass('open', currentTarget);

    const { top, height } = go(currentTarget, (el) => ({
      top: $position(el).top,
      height: el.getBoundingClientRect().height,
    }));

    const options = $el(
      optionsHtml({
        options: motions,
        selected_value,
        type,
        is_frame_select,
      }),
    );
    $append(options, $qs('.motion-controls'));

    Object.assign(options.style, {
      top: `${top + height + 8}px`,
      ...(is_frame_select && { right: 0 }),
      ...(type !== NessLabsSettingConstantS.MOTION_TYPES.WEAPON && { width: `${options.offsetWidth / 2}px` }),
    });

    const iscroll_wrap = $find('.wrapper', options);
    const iscroll_container = $find('.iscroll_container', options);

    if (iscroll_container.offsetHeight < iscroll_wrap.offsetHeight) {
      NessCustomMakerFrameShareF.iscroll_showed(options.parentElement);
    } else {
      iscroll_container.style.height = iscroll_wrap.offsetHeight + 'px';
    }
  }
};

export const closeCurrentOptions = () => {
  const open_options = $qs('.select-options');
  const open_select = $qs('.motion-select.open');

  if (open_options) {
    NessCustomMakerFrameShareF.iscroll_hiding(open_options);
    $remove(open_options);
  }
  if (open_select) {
    $removeClass('open', open_select);
  }
};
